import { useEffect, useState } from 'react';

import { shouldDisplayPopupCookies } from 'src/utils';

export default function useCookies() {
  const [shouldShowPopupCookies, setShouldShowPopupCookies] = useState<boolean>(false);

  useEffect(() => {
    setShouldShowPopupCookies(shouldDisplayPopupCookies());
  }, [setShouldShowPopupCookies]);

  return { shouldShowPopupCookies, setShouldShowPopupCookies };
}
